import React from "react";
import { Check, XCircle } from "lucide-react";

const STAGES = [
  { id: "submitted", label: "Submitted" },
  { id: "reviewing", label: "Reviewing" },
  { id: "in_progress", label: "In Progress" },
  { id: "completed", label: "Completed" },
];

const fmtTs = (iso) =>
  new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" }) +
  " · " +
  new Date(iso).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });

export const RequestTimeline = ({ request }) => {
  const cancelled = request.status === "cancelled";
  const reached = {};
  (request.history || []).forEach((h) => {
    if (!reached[h.status]) reached[h.status] = h.at;
  });
  const currentIdx = STAGES.findIndex((s) => s.id === request.status);

  return (
    <div className="pt-3" data-testid={`timeline-${request.id}`}>
      <div className="flex items-start">
        {STAGES.map((s, i) => {
          const done = !cancelled && currentIdx > i;
          const current = !cancelled && currentIdx === i;
          const isLastDone = current && s.id === "completed";
          const dotCls = done || isLastDone
            ? "bg-emerald-500 border-emerald-500 text-black"
            : current
            ? "bg-blue-600 border-blue-500 text-white animate-pulse"
            : cancelled && reached[s.id]
            ? "bg-zinc-700 border-zinc-600 text-zinc-400"
            : "bg-zinc-900 border-white/15 text-zinc-600";
          return (
            <React.Fragment key={s.id}>
              {i > 0 && (
                <div className={`flex-1 h-px mt-3 ${done || current ? "bg-emerald-500/60" : "bg-white/10"}`}></div>
              )}
              <div className="flex flex-col items-center w-20 flex-shrink-0" data-testid={`timeline-step-${request.id}-${s.id}`}>
                <div className={`w-6 h-6 rounded-full border flex items-center justify-center transition-colors ${dotCls}`}>
                  {done || isLastDone ? <Check className="w-3.5 h-3.5" /> : <span className="text-[9px] font-bold">{i + 1}</span>}
                </div>
                <span className={`text-[10px] font-semibold mt-1.5 ${done || current || isLastDone ? "text-zinc-200" : "text-zinc-600"}`}>
                  {s.label}
                </span>
                {reached[s.id] && (
                  <span className="text-[9px] text-zinc-500 font-mono mt-0.5 text-center leading-tight">{fmtTs(reached[s.id])}</span>
                )}
              </div>
            </React.Fragment>
          );
        })}
      </div>
      {cancelled && (
        <div className="mt-3 flex items-center space-x-2 text-[11px] text-rose-400 bg-rose-500/10 border border-rose-500/30 rounded-md px-3 py-2" data-testid={`timeline-cancelled-${request.id}`}>
          <XCircle className="w-3.5 h-3.5 flex-shrink-0" />
          <span>This request was cancelled{reached.cancelled ? ` on ${fmtTs(reached.cancelled)}` : ""}.</span>
        </div>
      )}
    </div>
  );
};
